import { Routes } from '@angular/router';
import { provideStates } from '@ngxs/store';
import { LyaAccessGuard } from './features/lya-space/guards/lya.guard';
import { LyaState } from './features/lya-space/state/lya.state';
import { MeetingAccessGuard } from './features/meetcall/guards/meetcall.guards';
import { MeetCallState } from './features/meetcall/state/meetcall.state';
import { SharedCvDataAccessGuard } from './features/shared-cv-data/shared-cv-data.guard';
import { SharedCvDataState } from './features/shared-cv-data/state/shared-cv-data.state';
import { AuthGuard } from './shared/guards/auth.guard';
import { messagesExtensionsFRResolver } from './state/resolvers/app.resolver';

export const routes: Routes = [
  {
    path: 'core',
    canActivate: [AuthGuard],
    resolve: {
      messagesExtensionsFRResolver,
    },
    loadChildren: () => import('./features/core/main/main.routes').then((m) => m.routes),
  },
  {
    path: 'portal',
    loadComponent: () => import('./features/t/t').then((m) => m.T),
    pathMatch: 'full',
  },
  {
    path: 'meetcall/:companyId/:data',
    providers: [provideStates([MeetCallState])],
    canActivate: [MeetingAccessGuard],
    loadComponent: () => import('./features/meetcall/meetcall').then((m) => m.Meetcall),
    pathMatch: 'full',
  },

  //il ressemble à meetcall mais c'est un autre state et un autre guard, c'est presQUE LE MEME, n'ivente rien presque,
  //fait attention à l'utilisation du clé: data, et companyId qui vient dans l params de l url
  //fait attention à l'intercepteur.
  {
    path: 'shared/cv-data/:companyId/:data',
    providers: [provideStates([SharedCvDataState])], // fait le state
    canActivate: [SharedCvDataAccessGuard], //fait le guard
    loadComponent: () =>
      import('./features/shared-cv-data/shared-cv-data').then((m) => m.SharedCvData),
    pathMatch: 'full',
  },
  {
    path: 'lya-space/:companyId/:id',
    providers: [provideStates([LyaState])],
    canActivate: [LyaAccessGuard],

    loadComponent: () =>
      import('./features/core/lya/mockups/lya-ai-split-welcome-v2/lya-ai-split-welcome-v2').then(
        (m) => m.LyaAiSplitWelcomeV2,
      ),
    pathMatch: 'full',
  },
  {
    path: 'translator-live/:sessionId',
    canActivate: [AuthGuard],
    loadComponent: () => import('./features/live-translator/live-translator').then(m => m.LiveTranslator),
  },
  {
    path: 'demo/translator-live',
    pathMatch: 'full',
    loadComponent: () => import('./features/live-translator/live-translator').then(m => m.LiveTranslator),
  },
  {
    path: 'demo/translator-live/:sessionId',
    loadComponent: () => import('./features/live-translator/live-translator').then(m => m.LiveTranslator),
  },
  {
    path: 'demo/live-translator',
    loadChildren: () => import('./features/live-translator/live-translator.routes').then(m => m.DEMO_LIVE_TRANSLATOR_ROUTES),
  },
  {
    path: 'demo/meetcall-kpi',
    providers: [provideStates([MeetCallState])],
    data: { mockMode: true },
    loadComponent: () => import('./features/meetcall/meetcall').then((m) => m.Meetcall),
    pathMatch: 'full',
  },
  {
    path: 'demo/1g-cv',
    loadComponent: () => import('./features/cv1g-demo/cv1g-demo').then((m) => m.Cv1gDemo),
    pathMatch: 'full',
  },
  {
    path: '404',
    //providers: [provideStates([MeetCallState])],
    //canActivate: [MeetingAccessGuard],
    loadComponent: () => import('./features/page404/page404').then((m) => m.Page404),
    pathMatch: 'full',
  },
  {
    path: '',
    redirectTo: 'core',
    pathMatch: 'full',
  },
];
